/**
 * Role reference click handlers - handling clicks on role references to zoom/navigate
 */

import { chartInstance } from '../state.js';
import { apiGet } from '../utils/apiClient.js';
import type { CirclePackNode } from '../../shared/types.js';
import { findNodeById } from './utils.js';
import { findD3NodeById } from '../utils/hierarchyUtils.js';

/**
 * Attach click handlers to role reference spans
 * Clicking a role reference will display that role and zoom to it in the chart
 */
export function attachRoleReferenceHandlers(
    displayNodeData: (node: CirclePackNode, editMode: boolean) => void,
    updateSelectedNodeTitle: (node: CirclePackNode) => void
): void {
    const references = document.querySelectorAll('.role-reference');
    references.forEach((ref) => {
        ref.addEventListener('click', async () => {
            const roleId = parseInt(ref.getAttribute('data-role-id') || '0');
            if (roleId) {
                if (!chartInstance) return;
                
                // Fetch fresh data for the panel
                const freshRoles = await apiGet<CirclePackNode | CirclePackNode[]>('/api/roles');
                const freshData = Array.isArray(freshRoles) ? freshRoles[0] : freshRoles;
                const freshNodeData = findNodeById(freshData, roleId);
                if (freshNodeData) {
                    displayNodeData(freshNodeData, false);
                    updateSelectedNodeTitle(freshNodeData);
                }
                
                // Use chart's data to get the full hierarchy with d3 nodes
                const dataRoot = chartInstance.data();
                const hierarchyRoot = (dataRoot as any)?.__dataNode;
                
                if (hierarchyRoot) {
                    const d3Node = findD3NodeById(hierarchyRoot, roleId);
                    if (d3Node) {
                        chartInstance.zoomToNode(d3Node.data, { __dataNode: d3Node });
                    }
                }
            }
        });
    });
}
